export default "__VITE_ASSET__3ee07996__"